import React, { Fragment, memo } from 'react';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';

import { useAppSelector } from '~/store';
import { patrolsAccountSelector, patrolsBundlesSelector } from '~/store/selectors/patrolsSelectors';

import { getPatrolRewardItemDataWE } from '~/pages/Patrols/helpers';
import StepCSSTransitionGroup from '~/UIKit/StepCSSTransitionGroup/StepCSSTransitionGroup';

import styles from './PatrolsBundlesList.module.scss';

type IProps = {
  animationLevel?: number;
  isDisabledAnimations?: boolean;
};

const PatrolsBundlesList: React.FC<IProps> = ({ animationLevel = 0, isDisabledAnimations = false }) => {
  const bundles = useAppSelector(patrolsBundlesSelector) || {};
  const account = useAppSelector(patrolsAccountSelector);

  return (
    <div className={styles.bundles}>
      {Object.values(bundles).map((bundle, bundleIndex) => {
        return (
          <StepCSSTransitionGroup
            className={styles.bundle}
            level={animationLevel * 4 + bundleIndex}
            key={`bundle_${bundleIndex}_${bundle.id}`}
            isDisabled={isDisabledAnimations}
            delay={0.025}
          >
            <div className={styles.items}>
              {bundle.rewards.map((reward, rewardIndex) => (
                <Fragment key={`reward_${rewardIndex}_${reward.id}`}>
                  <span className={!rewardIndex ? styles.itemsBullet : styles.itemsSpacer} />
                  {reward.items.map((item) => {
                    const itemDataWE = getPatrolRewardItemDataWE(item);
                    return (
                      <WoWSEntity
                        className={styles.reward}
                        type={itemDataWE.type}
                        id={itemDataWE.id}
                        amount={item.amount}
                        presentation={{
                          iconPosition: 'left',
                          renderWithoutFade: true,
                          withTooltip: true,
                        }}
                        key={`reward_${reward.id}_${item.id}`}
                      />
                    );
                  })}
                </Fragment>
              ))}
            </div>
            <div>{account?.claimedBundles.includes(bundle.id) ? 1 : 0}/1</div>
          </StepCSSTransitionGroup>
        );
      })}
    </div>
  );
};

export default memo(PatrolsBundlesList);
